module.exports = __webpack_public_path__ + "static/media/ios-woman.05033c78.svg";